import { lazy } from 'react';
const FreightChargeInq = lazy(() => import('./freightChargeInq'));

const freightChargeInqRoutes = [
  {
    path: '/freightChargeInq',
    component: FreightChargeInq
  }
];

export default freightChargeInqRoutes;
